import graphql__b9228ac4509f4c00ebb0 from "./__generated__/ConfirmPhoneNumberMutation.graphql.js";import { commitMutation, graphql } from "react-relay";
import mapValues from "lodash/mapValues";

import appRelayEnvironment from "../config/AppRelayEnvironment";

const mutation = graphql__b9228ac4509f4c00ebb0;

async function confirmPhoneNumber(form) {
  const variables = mapValues(form.fields, field => field.value);

  return new Promise((resolve, reject) => {
    commitMutation(appRelayEnvironment, {
      mutation,
      variables,
      onCompleted: (response, errors) => {
        if (errors) {
          reject(errors);
        } else {
          resolve(response);
        }
      },
      onError: error => {
        console.error(error);
        reject(error);
      }
    });
  });
}

export { confirmPhoneNumber };
